import { render, staticRenderFns } from "./forPatientDialog.vue?vue&type=template&id=5a7d2070"
import script from "./forPatientDialog.vue?vue&type=script&lang=js"
export * from "./forPatientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports